import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';

import styles from './styles.module.scss';

function ProfileMenu() {
  const dispatch = useDispatch();
  const isSecondaryHeader = useSelector((state) => state.core.settings?.secondaryHeader);
  const isOpen = useSelector((state) => state.modal[`${MODALS.PROFILE_MENU}ModalIsOpen`]);
  const { templateModel } = useSelector((state) => state.core);

  const handleClick = () => {
    if (isOpen) {
      dispatch(ModalActions.closeModal(MODALS.PROFILE_MENU));
    } else {
      dispatch(ModalActions.openModal(MODALS.PROFILE_MENU));
    }
  };

  return (
    <button
      type="button"
      className={cn(styles.hamburgerButton, {
        [styles.secondaryHeader]: isSecondaryHeader
      })}
      onClick={handleClick}>
      <span
        className={cn(styles[`icon${templateModel}`], {
          [styles.secondaryHeader]: isSecondaryHeader
        })}>
        <span className={`material-icons ${styles.iconHamburger}`}>menu</span>
      </span>
    </button>
  );
}

export default ProfileMenu;
